import { render, staticRenderFns } from "./gdpr-addendum.vue?vue&type=template&id=08c03250&scoped=true&"
import script from "./gdpr-addendum.vue?vue&type=script&lang=js&"
export * from "./gdpr-addendum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c03250",
  null
  
)

export default component.exports